export const ONBOARDING_SPACE_MISSION_CONTROL = {
	SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT:
		'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
	SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT:
		'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt',
} as const;

export const SpaceMissionControlOnboardingKeys = [
	...Object.values(ONBOARDING_SPACE_MISSION_CONTROL),
] as const;
